<template>
  <!-- eslint-disable max-len -->
  <div>
    <main class="instant-savings-mobile u-container">
      <h1 class="font-bold text-4xl">
        USPS Change-of-Address<sup>®</sup>
      </h1>
      <ProgressBar
        v-if="!showChoiceExperience"
        :steps="6"
        :current="5"
      />
      <IndividualProgressBarWithSteps
        v-if="showChoiceExperience"
        :mobile="true"
      />
      <h2
        ref="stepHeading"
        class="mt-2 text-xl"
      >
        <template v-if="!showChoiceExperience">
          Step 5:&nbsp;
        </template>
        <span class="font-bold">Would you like to receive special offers?</span>
      </h2>
      <p class="mt-4 text-base">
        Select "Yes" to get all the offers below delivered to <strong v-if="email">{{ email }}</strong><strong v-else>the email provided</strong> in a
        <strong>one-time email from USPS</strong> after you complete your USPS Change-of-Address.
      </p>
      <form
        ref="form"
        novalidate
        @submit.prevent="submit"
      >
        <div class="flex mt-6">
          <button
            id="offers-yes-btn"
            ref="offersYesBtn"
            type="button"
            :class="{ 'c-btn--secondary': offersOptIn !== 'YES' }"
            class="c-btn w-1/2"
            @click="selectOffersOptIn('YES')"
          >
            Yes
          </button>
          <button
            id="offers-no-btn"
            ref="offersNoBtn"
            type="button"
            :class="{ 'c-btn--secondary': offersOptIn !== 'NO' }"
            class="c-btn w-1/2 ml-4"
            @click="selectOffersOptIn('NO')"
          >
            No
          </button>
        </div>
        <p
          v-if="offersOptInError"
          class="errors text-red-200 text-sm font-bold mt-2"
        >
          Please make a selection.
        </p>
        <div
          v-if="offers && offers.length"
          class="flex flex-col items-center mt-6"
        >
          <component
            :is="getAmpComponent(template.schema.name)"
            v-for="({ accountId, accountName, adGroupId, id, template }, objectId) in offers"
            ref="offerTile"
            :key="id"
            :value="selectedOffers.includes(offers[objectId])"
            :account-id="accountId"
            :account-name="accountName"
            :ad-id="id"
            :ad-group-id="adGroupId"
            :alt-text="accountName"
            :background-url="template.properties.backgroundUrl"
            :cta="template.properties.cta"
            :headline="template.properties.headline"
            :legal-text="template.properties.legalText"
            :logo-url="template.properties.logoUrl"
            :short-description="template.properties.shortDescription"
            :tooltip="template.properties.tooltip"
            :template-id="template.id"
            class="instant-savings-mobile__offer-tile disable-hover"
            @selected:offer="toggleOfferSelect(offers[objectId])"
          />
        </div>
        <p class="mt-6 text-xs">
          Neither the U.S. Postal Service<sup>®</sup> nor any contractor associated with the operation of this website: (1) make any guarantee as to the accuracy of the statements made by the advertisers or the content of the editorial material on this website; (2) endorse any company, product or service listed or advertised in this MoversGuide Online™ product; (3) will be held liable in any manner for any claim, loss, expense, damage or consumer dissatisfaction arising out of or in connection with the use of the MoversGuide Online™ product; and (4) the advertising materials are free to the public and produced without the use of either tax or postal revenue.
        </p>
        <div class="c-hairline mt-6" />
        <StickyPanel class="mt-6">
          <template slot="buttons">
            <button
              id="next"
              ref="nextBtn"
              class="c-btn--mobile simplify__nav-button"
              :class="{ 'c-btn--disabled': !offersOptIn }"
              @click="analytics.click.next($route.params.orderUuid)"
            >
              Next
            </button>
          </template>
        </StickyPanel>
        <section class="py-6">
          <PrivacyActStatement />
        </section>
      </form>
    </main>
  </div>
</template>

<script>
import { AdvantageDouble, AdvantageSingle } from '@ampersend/mgo';
import {
  ProgressBar,
  IndividualProgressBarWithSteps,
} from '@mgo/ui/lib/components';
import { mobileAnalytics } from './analytics';
import InstantSavingsMixin from './mixin';
import PrivacyActStatement from '../../components/PrivacyActStatement.vue';
import StickyPanel from '../../components/StickyPanel.vue';

export default {
  name: 'MobileInstantSavings',
  components: {
    AdvantageDouble,
    AdvantageSingle,
    PrivacyActStatement,
    StickyPanel,
    ProgressBar,
    IndividualProgressBarWithSteps,
  },
  mixins: [InstantSavingsMixin],
  computed: {
    showNonControlExperience: () => JSON.parse(sessionStorage.getItem('showNonControlExperience')) ?? false,
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    analytics() {
      return mobileAnalytics();
    },
    schemaNames() {
      return ['MGO Advantage Single'];
    },
  },
};
</script>
